import React from 'react';
import PropTypes from 'prop-types';
import isNull from 'lodash/isNull';
import ProgressOnTable from './ProgressOnTable';
import NumberUtils from '../../utils/NumberUtils';

const msgPart = ' last month';

function getBudgetMessage(currentMonth, budgetValue) {
  if (currentMonth < budgetValue) {
    return 'Less than' + msgPart;
  } else if (currentMonth > budgetValue) {
    return 'More than' + msgPart;
  }
  return 'Same as' + msgPart;
}

function SpendTableRowTemplateMobile({
  content: { spendingHeaderThisMonthText, spendingTableHeaderText7 },
  rowData,
  customClick = () => {},
}) {
  const {
    last_month: budgetValue,
    current_month: currentMonth,
    archived,
    joint,
    name,
    difference,
  } = rowData;

  return (
    <div className="transaction-row">
      <div onClick={() => customClick(name, rowData)}>
        <label className={archived || joint ? 'column-fade' : ''}>
          <span className="icon icon-tag" />
          {name}
        </label>
        <section className="progress-section">
          <ProgressOnTable rowData={rowData} />
        </section>
        <section>
          <p>{spendingHeaderThisMonthText}</p>
          <p>{spendingTableHeaderText7}</p>
          <p>
            {getBudgetMessage(
              Math.abs(Number(currentMonth)),
              Math.abs(Number(budgetValue))
            )}
          </p>
        </section>
        <section>
          <h5>{NumberUtils.appendCurrency('{}', currentMonth)}</h5>
          <h5>{NumberUtils.appendCurrency('{}', budgetValue)}</h5>
          <h5>
            {NumberUtils.appendCurrency(
              '{}',
              isNull(difference)
                ? Number(budgetValue) + Number(currentMonth)
                : difference
            )}
          </h5>
        </section>
      </div>
    </div>
  );
}

SpendTableRowTemplateMobile.propTypes = {
  rowData: PropTypes.object,
  customClick: PropTypes.func,
  content: PropTypes.object,
};

export { SpendTableRowTemplateMobile };
